"use strict";

import { io } from "socket.io-client";

export const socket = io("https://demos.inter.mx", {
  autoConnect: false,
  path: "/policies/events.io",
});
